import enviro from 'enviro';
import invariant from 'react-utils/invariant';
import * as InboundDbMetaTypeIds from 'automation-ui-references/object-types/InboundDbMetaTypeIds';
const ReverseEnumMapping = Object.fromEntries(Object.entries(InboundDbMetaTypeIds).map(([name, id]) => [id, name]));
export const getPropertyChangeInnerId = () => enviro.isQa() ? 67284 : 655002;
export const normalizeMetaTypeId = metaTypeId => {
  return ReverseEnumMapping[metaTypeId] || metaTypeId;
};
export const parseEventTypeId = typeId => {
  const match = typeId.match(/(\d)-(\d+)/);
  invariant(match && match[1] && match[2], `Invalid eventTypeId: ${typeId}`);
  return {
    metaType: Number(match[1]),
    innerId: Number(match[2])
  };
};
export const getEventTypeIdFromObj = eventTypeIdObj => {
  return `${InboundDbMetaTypeIds[eventTypeIdObj.metaType]}-${eventTypeIdObj.innerId}`;
};
export const getEventTypeId = filter => {
  const eventTypeInnerId = filter.getEventTypeInnerId();
  const eventTypeMetaId = filter.getEventTypeMetaType();
  return eventTypeInnerId ? `${eventTypeMetaId}-${eventTypeInnerId}` : null;
};

/**
 * Returns only filters that can be used for event enrollment
 *
 * @param eventFilters FlowEventFilter[]
 * @returns FlowEventFilter[]
 */
export const getEnrollmentEventFilters = eventFilters => {
  // Enrollment = FIRST_TIME_ENROLLMENT
  // Re-enrollment = ANY_ENROLLMENT
  return eventFilters.filter(eventFilter => ['FIRST_TIME_ENROLLMENT', 'ANY_ENROLLMENT'].includes(eventFilter.flowEventFilterType));
};